import { create } from 'zustand';
import * as Sentry from '@sentry/react';
import { storage } from './storage';

export type AuthUser = {
  id: string;
  email?: string;
  name?: string;
  terms?: boolean;
  [key: string]: unknown;
};

type AuthState = {
  user: AuthUser | null;
  token: string | null;
  setAuth: (user: AuthUser, token: string) => void;
  clearAuth: () => void;
};

export const useAuthStore = create<AuthState>(set => ({
  user: storage.getUser<AuthUser>(),
  token: storage.getToken(),
  setAuth: (user, token) => {
    storage.setToken(token);
    storage.setUser(user);
    Sentry.setUser({ id: user.id, email: user.email });
    set({ user, token });
  },
  clearAuth: () => {
    storage.clearToken();
    storage.clearUser();
    Sentry.setUser(null);
    set({ user: null, token: null });
  },
}));

// Identify already-logged-in user on app start
const initialUser = useAuthStore.getState().user;
if (initialUser) {
  Sentry.setUser({ id: initialUser.id, email: initialUser.email });
}

export const getAuthToken = () => useAuthStore.getState().token;
export const getAuthUser = () => useAuthStore.getState().user;
